"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _base = babelHelpers.interopRequireDefault(require("./base"));

var _decorators = require("decorators");

var _animationHelper = babelHelpers.interopRequireDefault(require("animation-helper"));

var _class, _temp;

var Queue =
/*#__PURE__*/
function () {
  function Queue() {
    babelHelpers.classCallCheck(this, Queue);
    this._callers = [];
    this.finished = [];
  }

  babelHelpers.createClass(Queue, [{
    key: "_caller",
    value: function _caller() {
      var index = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;

      try {
        throw new Error();
      } catch (e) {
        try {
          return e.stack.split('\n')[2 + index].replace(/^\s*at\s/, '');
        } catch (e) {
          return "<Unknown caller: no stack>";
        }
      }
    }
  }, {
    key: "push",
    value: function push() {
      var c = this._caller(1);

      this._callers.push(c);
    }
  }, {
    key: "pop",
    value: function pop() {
      this._callers.pop();

      if (!this.count) {
        while (this.finished.length) {
          var fin = this.finished.shift();
          fin();
        }
      }
    }
  }, {
    key: "listen",
    value: function listen(f) {
      var now = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      if (now && !this.count) f();else this.finished.push(f);
    }
  }, {
    key: "count",
    get: function get() {
      return this._callers.length;
    },
    set: function set(v) {
      if (v < this._callers.length) this._callers.length = v;else while (v > this._callers.length) {
        this.callers.push(this._caller(1));
      }
    }
  }]);
  return Queue;
}();

var Test = (_class = (_temp =
/*#__PURE__*/
function (_Activity) {
  babelHelpers.inherits(Test, _Activity);

  function Test() {
    var _babelHelpers$getProt;

    var _this;

    babelHelpers.classCallCheck(this, Test);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = babelHelpers.possibleConstructorReturn(this, (_babelHelpers$getProt = babelHelpers.getPrototypeOf(Test)).call.apply(_babelHelpers$getProt, [this].concat(args)));
    _this._showResults = false;
    _this._bannerShowing = false;
    _this._isChallengeQuestion = false;
    _this._canRetake = false;
    _this._correctImage = null;
    _this._incorrectImage = null;
    _this._canResume = false;
    _this._queue = new Queue();
    _this._questionsAnsweredCorrect = {};
    return _this;
  }

  babelHelpers.createClass(Test, [{
    key: "setupTestActivity",
    value: function setupTestActivity(canRetake, isChallengeQuestion, correctImage, incorrectImage, canResume) {
      var _this2 = this;

      this.alwaysShowCompletionBanner = true;
      this._isChallengeQuestion = isChallengeQuestion;
      this._canRetake = canRetake;
      this._correctImage = correctImage;
      this._incorrectImage = incorrectImage;
      this._canResume = canResume;

      if (canResume) {
        this.addEventListener('startActivity', function () {
          return _this2.useExistingActivity();
        });
      }

      this.addEventListener('showFinishedBanner', this._test_showFinishedBanner);

      if (!this.readOnly) {
        this.addEventListener('startedActivity', this._test_startedActivity);
        this.addEventListener('endedActivity', this._test_endedActivity);
        this.addEventListener('timerExpired', this._test_timerExpired);
      }

      this.$('.activity-body').empty();
      this.showActivityTitle();
      var testQuestion = document.createElement('div');
      testQuestion.className = 'question-block';
      testQuestion.innerHTML = "\n\t\t\t<div class='media-object'>\n\t\t\t\t<div class='media-container'>\n\t\t\t\t\t<img>\n\t\t\t\t</div>\n\t\t\t</div>\n\t\t\t<div class='section-item test-question container'>\n\t\t\t\t<div class='row'>\n\t\t\t\t\t<div class='h2 question-text col-xs-12 col-sm-12 col-md-10 col-md-offset-1'></div>\n\t\t\t\t\t<div class='h4 help-text col-xs-12 col-sm-12 col-md-10 col-md-offset-1 hidden'>Select all correct answers</div>\n\t\t\t\t</div>\n\t\t\t\t<div class='section-item test-answer container'>\n\t\t\t\t\t<!-- header><h4>What is your answer</h4></header -->\n\t\t\t\t\t<div class='row'>\n\t\t\t\t\t\t<div class='answer-list col-xs-12 col-sm-12 col-md-10 col-md-offset-1'></div>\n\t\t\t\t\t</div>\n\t\t\t\t</div>\n\t\t\t\t<div class='activity-action-button center-block test-next'>\n\t\t\t\t\t<button class='btn btn-primary' type='button' data-spin='true'>Continue</button>\n\t\t\t\t\t<button class='btn btn-link' type='button' data-spin='true' data-previous='true'>Back to previous question</button>\n\t\t\t\t</div>\n\t\t\t</div>\n\t\t";
      this._testQuestion = testQuestion;
      this._currentQuestion = 0;
      this.addEventListener('showTestResult', this._test_showTestResult);

      if (this.readOnly) {
        this.addEventListener('activityComplete', this._test_readOnlyActivityComplete);
        this.activityComplete();
      } else {
        this.addEventListener('startedActivity', this._test_writableStartedActivity);
        this.addEventListener('endedActivity', function () {
          return _this2.activityComplete();
        });
        this.startActivity();
      }
    }
  }, {
    key: "_test_writableStartedActivity",
    value: function _test_writableStartedActivity(event) {
      var _this3 = this;

      this.lmsGet("testStatus/".concat(this.startActivityState.statementID), function (data) {
        _this3.testStatus = data;

        if (_this3.startActivityState.details.Test.showSingleQuestion) {
          var sqo = _this3.testStatus.detail.Test.questions.filter(function (question) {
            return question.answers.filter(function (answer) {
              return answer.selectedThisAnswer;
            }).length == 0;
          })[0];

          if (!sqo) _this3._showQuestion(_this3.startActivityState.details.Test.questions.length - 1);else _this3._showQuestion(_this3.testStatus.detail.Test.questions.indexOf(sqo));
        } else {
          while (_this3._currentQuestion < _this3.startActivityState.details.Test.questions.length) {
            _this3._showQuestion(_this3._currentQuestion++);
          }

          setTimeout(function () {
            var cct = $(document).scrollTop();
            $(document).scrollTop(cct + _this3.$().offset().top);
          }, 0);

          _this3.showButton('Continue', 'continue-button', 'finsih-test', 'finishedTestButtonClick', null, false, 'btn-primary-alt');

          _this3.addEventListener('finishedTestButtonClick', function (event) {
            _this3.stopTimer();

            _this3.hideTimer();

            _this3.clearPosition();

            _this3._doEndActivity('', true);
          });
        }
      });
    }
  }, {
    key: "_test_readOnlyActivityComplete",
    value: function _test_readOnlyActivityComplete(event) {
      var questions = [],
          answers = [],
          correctAnswers = [],
          feedback = [];
      this.endActivityState.result.Test.questions.forEach(function (question, number) {
        questions.push({
          question: question,
          number: number
        });
        var answer = question.answer,
            correctAnswer = question.correctAnswer,
            fb = question.feedback;
        answers.push(answer);
        correctAnswers.push(correctAnswer);
        feedback.push(fb);
      });
      this.dispatchEvent(this._event('showTestResult', false, {
        success: this.endActivityState.success,
        questions: questions,
        answers: answers,
        correctAnswers: correctAnswers,
        feedback: feedback
      }));

      if (this._canRetake && !this.endActivityState.success) {
        this.showTryAgainButton('Try again');
      }
    }
  }, {
    key: "_showQuestion",
    value: function _showQuestion(currentQuestion) {
      var _this4 = this;

      if (this.startActivityState.details.Test.selectRandomQuestions) {
        var v = [];

        for (var i = 0; i < this.startActivityState.details.Test.questions.length; i++) {
          if (!this._questionsAnsweredCorrect[i]) v.push(i);
        }

        currentQuestion = v[Math.floor(Math.random() * v.length)];
      }

      var qn = currentQuestion;
      var theQuestion = this.startActivityState.details.Test.questions[qn];
      var theStatus = this.testStatus.detail.Test.questions[qn];

      var qBlock = this._testQuestion.cloneNode(true);

      qBlock.dataset.question = qn;
      if (theQuestion.answerMultiple) $(qBlock).find('.h4.help-text').removeClass('hidden');else $(qBlock).find('.h4.help-text').remove();
      var mm;

      if (theQuestion.questionImage) {
        $(qBlock).find('img').attr('src', theQuestion.questionImage);
        mm = {
          sel: "[data-question=\"".concat(qn, "\"] img"),
          constraint: theQuestion.displayConstraint
        };
      } else {
        $(qBlock).find('.media-object').remove();
      }

      if (mm && mm.constraint && mm.constraint.mode == 'Column') {
        var mr = document.createElement('div');
        mr.className = "container media-wrapper";
        $(mr).append($(qBlock).find('.media-object'));
        $(mr).find('.media-object').addClass('row');
        $(mr).find('.media-container').addClass('col-xs-12 col-sm-12 col-md-10 col-md-offset-1');
        $(qBlock).prepend(mr);
      }

      $(qBlock).find('.question-text').html(theQuestion.question);

      for (var i = 0; i < theQuestion.answers.length; i++) {
        var aa = document.createElement('div');
        aa.className = "radio ".concat(theQuestion.answerMultiple ? 'multi' : '');
        var wrap = ['', '']; // If the answer contains no tags, wrap it in a <p>.

        if (theQuestion.answers[i].answerText.indexOf('<') == -1) wrap = ['<p>', '</p>'];
        aa.innerHTML = "\n\t\t\t\t<label class='h3'>\n\t\t\t\t\t<input type='".concat(theQuestion.answerMultiple ? 'checkbox' : 'radio', "' name='question").concat(qn).concat(theQuestion.answerMultiple ? "_".concat(i) : '', "' value='").concat(i, "'>\n\t\t\t\t\t<div class='htmlAnswer'>").concat(wrap[0]).concat(theQuestion.answers[i].answerText).concat(wrap[1], "</div>\n\t\t\t\t</label>\n\t\t\t");
        if (!this.startActivityState.details.Test.selectRandomQuestions && theStatus.answers[i].selectedThisAnswer) aa.querySelector('input').checked = true;
        qBlock.querySelector('.answer-list').appendChild(aa);
      }

      var cbl = [];

      var cb = function cb() {
        cbl.forEach(function (cb) {
          if (cb) cb();
        });
      };

      if (this.startActivityState.details.Test.showSingleQuestion) {
        cbl.push(this.emptyContainer());
        this.showActivityTitle();
        if (!currentQuestion || this._isChallengeQuestion) $(qBlock.querySelector('.test-next button[data-previous=true]')).remove();
        $(qBlock).find('.test-next button').on('click', function (event) {
          var target = event.currentTarget;

          if (target.dataset.previous == 'true') {
            _this4._showQuestion(currentQuestion - 1);
          } else if (theQuestion.answerMultiple) {
            var answers = [];
            $(qBlock).find('input:checked').each(function () {
              answers.push(Number(this.value));
            });

            _this4._doAnswerQuestion(qn, answers);
          } else if (qBlock.querySelector('input:checked')) {
            _this4._doAnswerQuestion(qn, Number(qBlock.querySelector('input:checked').value));
          } else {
            event.stopPropagation();
          }
        });
        cbl.push(this.appendQuestion(qBlock));
      } else {
        $(qBlock.querySelector('.test-next')).remove();
        $(qBlock).find(':input').on('click', function (_ref) {
          var target = _ref.currentTarget;
          var theAnswer;

          if (theQuestion.answerMultiple) {
            theAnswer = [];
            $(qBlock).find('input:checked').each(function () {
              theAnswer.push(Number(this.value));
            });
          } else {
            theAnswer = $(qBlock).find('input:checked').val();
          }

          _this4._doAnswerQuestion(qn, theAnswer);
        });
        this.$('.activity-bpdy').append(qBlock);
      }

      this.$().trigger('embedded-video');
      if (mm) this.setupResize(mm.sel, mm.constraint, null, cb);else cb();

      if (this.startActivityState.details.Test.showSingleQuestion) {
        var td = this.startActivityState.details.Test;
        var qc;
        if (td.selectRandomQuestions) qc = td.numberCorrectToContinue;else qc = td.questions.length;
        if (qc > 1) this.setPosition(1 + currentQuestion, qc);
        $(qBlock).find(':input').on('click', function () {
          var tp = _this4.$('.question-block').offset().top + _this4.$('.question-block').outerHeight();

          tp -= $(window).height();
          var sp = $(document).scrollTop();
          var d = tp - sp;
          var cst = sp;

          if (d > 0) {
            var a = new _animationHelper.default(1500, 'ease-in-out', function (percent) {
              var px = percent * d;
              $(document).scrollTop(sp + px);
              cst = $(document).scrollTop();
            }, function () {
              $(document).off('scroll.test-button');
            });
            a.start();

            var sh = function sh() {
              var sp = $(document).scrollTop();

              if (Math.abs(cst - sp) > 10) {
                a.stop();
                $(document).off('scroll.test-button');
              }
            };

            $(document).on('scroll.test-button', sh);
          }
        });
      }
    }
  }, {
    key: "_doAnswerQuestion",
    value: function _doAnswerQuestion(number, answer) {
      var _this5 = this;

      if (answer === void 0 || answer === null) return;

      this._queue.push();

      this.lmsPost("answeredQuestion/".concat(this.startActivityState.statementID), {
        questionNumber: number,
        answer: answer
      }, function (rv) {
        _this5.lmsGet("testStatus/".concat(_this5.startActivityState.statementID), function (rv) {
          _this5.testStatus = rv;
        });

        if (_this5.startActivityState.details.Test.showSingleQuestion) {
          if (_this5.startActivityState.details.Test.mustAnswerCorrect) {
            if (rv.isCorrect) {
              _this5._questionsAnsweredCorrect[number] = true;
            }

            _this5.dispatchEvent(_this5._event('showTestResult', false, {
              success: rv.isCorrect,
              questions: [{
                number: number,
                question: _this5.startActivityState.details.Test.questions[number]
              }],
              answers: [Array.isArray(answer) ? answer : Number(answer)],
              correctAnswers: ['currectAnswer' in rv ? rv.correctAnswer : false],
              feedback: [rv.feedbackMessage]
            }));

            if (rv.advanceToNext) {
              var qc, qp;

              if (_this5.startActivityState.details.Test.selectRandomQuestions) {
                qc = _this5.startActivityState.details.Test.numberCorrectToContinue;
                qp = Object.keys(_this5._questionsAnsweredCorrect).length;
              } else {
                qc = _this5.startActivityState.details.Test.questions.length;
                qp = number;
              }

              if (qp + 1 >= qc) {
                _this5.stopTimer();

                _this5.hideTimer();

                _this5.clearPosition();

                _this5._doEndActivity('', true);
              } else {
                _this5.$('.activity-body').append("\n\t\t\t\t\t\t\t\t<div class='next-button activity-action-button'>\n\t\t\t\t\t\t\t\t\t<button class='btn btn-primary' type='button' data-spin='true'>\n\t\t\t\t\t\t\t\t\t\tContinue\n\t\t\t\t\t\t\t\t\t</button>\n\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t");

                _this5.$('.activity-body .next-button button').on('click', function (event) {
                  _this5._showQuestion(number + 1);
                });
              }
            } else {
              _this5.dispatchEvent(_this5._event('showFinishedBanner', true, {
                state: {
                  percent: 0,
                  result: {
                    Test: {
                      passPercent: 100
                    }
                  },
                  success: false,
                  tryAgain: true
                }
              }));

              _this5.dispatchEvent(_this5._event('showingFinishedBanner'));

              _this5.showTryAgainButton('Try again', function () {
                _this5.hideFinishedBanner();

                _this5._showQuestion(number);
              });
            }
          } else {
            if (_this5.startActivityState.details.Test.questions.length == number + 1) {
              _this5.stopTimer();

              _this5.hideTimer();

              _this5.clearPosition();

              _this5._doEndActivity('', true);
            } else {
              _this5._showQuestion(number + 1);
            }
          }
        }

        _this5._queue.pop();
      });
    }
  }, {
    key: "_finishTest",
    value: function _finishTest() {
      var _this6 = this;

      this._queue.listen(function () {
        _this6.stopTimer();

        _this6.endActivity();

        _this6.hideTimer();

        _this6.clearPosition();
      }, true);
    }
  }, {
    key: "_test_showTestResult",
    value: function _test_showTestResult(event) {
      var _this7 = this;

      this.scrollToTop();
      this.$('.activity-body').empty();
      this.showActivityTitle();
      var item = document.createElement('div');
      item.innerHTML = "\n\t\t\t<div class='media-object'>\n\t\t\t\t<div class='medai-container'>\n\t\t\t\t\t<img>\n\t\t\t\t</div>\n\t\t\t</div>\n\t\t\t<div class='section-item test-question result container'>\n\t\t\t\t<div class='row'>\n\t\t\t\t\t<div class='h2 question-text col-xs-12 col-sm-12 col-md-10 col-md-offset-1'></div>\n\t\t\t\t</div>\n\t\t\t</div>\n\t\t\t<div class='section-item test-answer result container'>\n\t\t\t\t<div class='row'>\n\t\t\t\t\t<div class='col-xs-12 col-sm-12 col-md-10 col-md-offset-1'>\n\t\t\t\t\t\t<header><h4></h4></header>\n\t\t\t\t\t\t<div class='answer-list'></div>\n\t\t\t\t\t\t<div class='answer-feedback'>\n\t\t\t\t\t\t\t<span class='feedback-icon'>\n\t\t\t\t\t\t\t\t<span class='material-icons' data-icon='info'></span>\n\t\t\t\t\t\t\t</span>\n\t\t\t\t\t\t\t<span class='feedback-text'></span>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t</div>\n\t\t\t\t</div>\n\t\t\t</div>\n\t\t";
      item.className = 'result';

      if (this.endActivityState) {
        var tr = this.endActivityState.result.Test;
        var score = tr.totalCorrect / tr.questionCount;
        score = Math.round(100 * score);
        this.$('.score > span').text(score);
      }

      var resizeItems = [];
      event.questions.forEach(function (theQuestion, index) {
        var qd = item.cloneNode(true);
        qd.className = "result-".concat(index + 1, " result");
        var qClass = ".result-".concat(index + 1);
        var i = index;
        var mm = {
          wrap: qClass,
          sel: "".concat(qClass, " .media-object img"),
          constraint: theQuestion.question.displayConstraint
        };
        var isCorrect = false;

        if (event.correctAnswers[i] !== false) {
          if (theQuestion.question.answerMultiple) {
            var ca = event.correctAnswers[i];

            if (event.answers[i].length == ca.length) {
              if (event.answers[i].filter(function (value) {
                return ca.indexOf(value) != -1;
              }).length == event.answers[i].length) isCorrect = true;
            }
          } else {
            var cal = event.correctAnswers[i],
                al = event.answers[i];
            if (!Array.isArray(cal)) cal = [cal];
            if (Array.isArray(al)) al = al[0];
            if (cal.indexOf(al) != -1) isCorrect = true;
          }
        }

        if (isCorrect) {
          qd.className = "".concat(qd.className, " success");
          qd.querySelector('header h4').textContent = 'Correct';
        } else {
          qd.className = "".concat(qd.className, " failure");
          qd.querySelector('header h4').textContent = 'Incorrect';
        }

        if (event.questions.length > 1 && !_this7.startActivityState.details.Test.selectRandomQuestions) qd.querySelector('.question-text').dataset.questionNumber = 1 + theQuestion.number;
        qd.querySelector('.question-text').innerHTML = theQuestion.question.question;
        var q = theQuestion.question;

        if (q.questionImage) {
          qd.querySelector('img').src = q.questionImage;
          resizeItems.push(mm);
        } else {
          $(qd.querySelector('.media-object')).remove();
        }

        q.answers.forEach(function (answer, j) {
          var theAnswer = document.createElement('div');
          theAnswer.innerHTML = "\n\t\t\t\t\t<div class='h3'>\n\t\t\t\t\t\t<span class='icon'></span>\n\t\t\t\t\t\t<div class='text'></div>\n\t\t\t\t\t</div>\n\t\t\t\t";
          var wrap = ['', ''];
          if (answer.answerText.indexOf('<') == -1) wrap = ['<p>', '</p>'];
          theAnswer.querySelector('.text').innerHTML = "<div class='inline-answer'>".concat(wrap[0]).concat(answer.answerText).concat(wrap[1], "</div>");
          var aa = Array.isArray(event.answers[i]) ? event.answers[i] : [event.answers[i]];
          if (aa.indexOf(j) != -1) theAnswer.className = 'selected';
          var isPossibleCorrect = false;

          if (event.correctAnswers[i] !== false) {
            if (Array.isArray(event.correctAnswers[i])) {
              if (event.correctAnswers[i].indexOf(j) != -1) isPossibleCorrect = true;
            } else {
              if (event.correctAnswers[i] === j) isPossibleCorrect = true;
            }
          }

          if (isPossibleCorrect) {
            theAnswer.className += ' correct-answer';
            theAnswer.querySelector('.icon').innerHTML = "<span class='material-icons hide-icon' data-icon='check'><img class='img-responsive' src='".concat(_this7._correctImage, "'></span> ");
          } else if (theAnswer.className == 'selected') {
            theAnswer.querySelector('.icon').innerHTML = "<span class='material-icons hide-icon' data-icon='close'><img class='img-responsive' src='".concat(_this7._incorrectImage, "'></span> ");
          } else {
            theAnswer.querySelector('.icon').innerHTML = "<span class='material-icons hidden-icon'></span> ";
          }

          qd.querySelector('.answer-list').appendChild(theAnswer);
        });
        if (event.feedback[i]) qd.querySelector('.answer-feedback .feedback-text').textContent = event.feedback[i];else $(qd.querySelector('.answer-feedback')).remove();

        _this7.$('.activity-body').append(qd);
      });
      resizeItems.forEach(function (item) {
        if (item.constraint && item.constraint.mode == 'Column') {
          var qBlock = _this7.$(item.wrap);

          qBlock.prepend("<div class='container media-wrapper'></div>");
          qBlock.find('.media-wrapper').append(qBlock.find('.media-object'));
          qBlock.find('.media-object').addClass('row');
          qBlock.find('.media-container').addClass('col-xs-12 col-sm-12 col-md-10 col-md-offset-1');
        }

        _this7.setupResize(item.sel, item.constraint);
      });
    }
  }, {
    key: "_test_startedActivity",
    value: function _test_startedActivity(event) {
      if (event.activity.endTime) {
        var et = new Date(event.activity.endTime),
            st = new Date(event.activity.startTime);
        this.startTimer(et.getTime() - st.getTime(), false);
      }

      if (event.activity.details.Test.showSingleQuestion) {
        if (event.activity.details.Test.mustAnswerCorrect) {
          this._showResults = false;
        } else {
          this._showResults = true;
        }
      } else {
        this._showResults = true;
      }
    }
  }, {
    key: "_test_endedActivity",
    value: function _test_endedActivity(event) {
      if (this._showResults) {
        var questions = [],
            answers = [],
            correctAnswers = [],
            feedback = [];
        event.endActivityState.result.Test.questions.forEach(function (question, number) {
          var answer = question.answer,
              correctAnswer = question.correctAnswer,
              fb = question.feedback;
          questions.push({
            number: number,
            question: question
          });
          answers.push(answer);
          correctAnswers.push(correctAnswer);
          feedback.push(fb);
        });
        this.dispatchEvent(this._event('showTestResult', false, {
          success: event.endActivityState.success,
          questions: questions,
          answers: answers,
          correctAnswers: correctAnswers,
          feedback: feedback
        }));
      }

      if (this._canRetake && !event.endActivityState.success) {
        if (this.startActivityState.details.Test.showReview) {
          this.showReviewLink(this.startActivityState.details.Test.reviewText);
        }

        this.showTryAgainButton('Try again');
      }
    }
  }, {
    key: "_test_timerExpired",
    value: function _test_timerExpired(event) {
      this.stopTimer();
      this.hideTimer();
      this.clearPosition();

      this._doEndActivity('Time is up');
    }
  }, {
    key: "showOutOfTimeModal",
    value: function showOutOfTimeModal() {
      var prefix = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "";
      $('body').append("\n\t\t\t<div class='modal fade' id='out-of-time-modal'>\n\t\t\t\t<div class='modal-dialog'>\n\t\t\t\t\t<div class='modal-content'>\n\t\t\t\t\t\t<div class='modal-body'>\n\t\t\t\t\t\t\t<div style='text-align: center;'>\n\t\t\t\t\t\t\t\t<span class='loader'></span>\n\t\t\t\t\t\t\t\t<br>\n\t\t\t\t\t\t\t\t<h3>".concat(prefix, " Your test is now being submitted...</h3>\n\t\t\t\t\t\t\t\t<p>Please do not leave this page or close your browser until this process has completed.</p>\n\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t</div>\n\t\t\t\t</div>\n\t\t\t</div>\n\t\t"));
      $('#out-of-time-modal').modal({
        show: true,
        keyboard: false,
        backdrop: 'static'
      });
    }
  }, {
    key: "appendQuestion",
    value: function appendQuestion(block) {
      this.$('.activity-body').append(block);
    }
  }, {
    key: "emptyContainer",
    value: function emptyContainer() {
      this.$('.activity-body').empty();
    }
  }, {
    key: "_test_showFinishedBanner",
    value: function _test_showFinishedBanner(event) {
      var es = this.endActivityState;
      if (event.state) es = event.state;

      if (es.result.Test.isUnscored) {
        if (!this.readOnly) {
          event.preventDefault();
        }

        return;
      }

      event.preventDefault();
      var strings = {
        success: function success(_ref2) {
          var score = _ref2.score;
          return "<h4>You passed with a score of ".concat(score, "!</h4><h5>Nice work!</h5>");
        },
        failNoRetry: function failNoRetry(_ref3) {
          var score = _ref3.score,
              pass = _ref3.pass;
          return "<h4>You scored ".concat(score, ".</h4><h5>").concat(pass, " is required to pass.</h5>");
        },
        failMustRetry: function failMustRetry(arg) {
          return strings.failNoRetry(arg);
        },
        failCanRetry: function failCanRetry(arg) {
          return strings.failNoRetry(arg);
        },
        failCanRetryLimit: function failCanRetryLimit(_ref4) {
          var score = _ref4.score,
              pass = _ref4.pass,
              count = _ref4.count;
          return "<h4>You scored ".concat(score, ".</h4><h5>").concat(pass, " is required to pass. You can try again ").concat(count, " more time").concat(count == 1 ? '' : 's', ".</h5>");
        }
      };

      if (this._isChallengeQuestion) {
        strings = {
          success: function success() {
            return "<h4>Your answer is correct!</h4><h5>Good job!</h5>";
          },
          failNoRetry: function failNoRetry() {
            return "<h4>Your answer is incorrect.</h4><h5>Better luck next time.</h5>";
          },
          failMustRetry: function failMustRetry() {
            return "<h4>Your answer is incorrect.</h4>";
          },
          failCanRetry: function failCanRetry() {
            return strings.failMustRetry();
          },
          failCanRetryLimit: function failCanRetryLimit(_ref5) {
            var count = _ref5.count;
            return "".concat(strings.failMustRetry(), "<h5>You can try again ").concat(count, " more time").concat(count == 1 ? '' : 's', ".</h5>");
          }
        };
      }

      var string,
          replacements = {
        button: 'NEXT'
      };
      if (es.completedCourse) replacements.button = 'FINISH';
      if (es.percent) replacements.score = "".concat(es.percent, "%");else replacements.score = "".concat(Math.round(100 * (es.result.Test.totalCorrect / es.result.Test.questionCount)), "%");
      replacements.pass = es.result.Test.passPercent + '%';
      replacements.count = 0;
      if ('maxAttemptCount' in es.result.Test) replacements.count = es.result.Test.maxAttemptCount - es.result.Test.currentAttempt;
      replacements.s = replacements.count == 1 ? '' : 's';
      if (es.success) string = strings.success;else {
        if (es.tryAgain || this._canRetake) {
          if (!this.endActivityState) string = strings.failMustRetry;else if ('maxAttemptCount' in es.result.Test) string = replacements.count ? strings.failCanRetryLimit : strings.failNoRetry;else if (this.endActivityState && this.endActivityState.restartActivity) string = strings.failMustRetry;else string = strings.failCanRetry;
        } else {
          string = strings.failNoRetry;
        }
      }
      var b = "<div class='finished-banner ".concat(es.success ? '' : 'failed', "'>\n\t\t\t").concat(string(replacements), "\n\t\t</div>");
      this.$('.activity-subheader').append(b);

      if (this._canRetake && !this.endActivityState.success) {
        this.showTryAgainButton('Try again');
      }
    }
  }, {
    key: "_hideOutOfTimeModal",
    value: function _hideOutOfTimeModal() {
      $('#out-of-time-modal').modal('hide');
      this.removeEventListener('endedActivity', this._hideOutOfTimeModal);
    }
  }, {
    key: "_doEndActivity",
    value: function _doEndActivity(prefix, isUserInitiated) {
      var _this8 = this;

      if (!isUserInitiated || !this._isChallengeQuestion) {
        this.showOutOfTimeModal(prefix);
        this._showResults = true;
        this.addEventListener('endedActivity', this._hideOutOfTimeModal);
        setTimeout(function () {
          return _this8.endActivity();
        }, isUserInitiated ? 500 : 5000);
      } else {
        this.endActivity();
      }
    }
  }]);
  return Test;
}(_base.default), _temp), (babelHelpers.applyDecoratedDescriptor(_class.prototype, "_test_writableStartedActivity", [_decorators.autobind], Object.getOwnPropertyDescriptor(_class.prototype, "_test_writableStartedActivity"), _class.prototype), babelHelpers.applyDecoratedDescriptor(_class.prototype, "_test_readOnlyActivityComplete", [_decorators.autobind], Object.getOwnPropertyDescriptor(_class.prototype, "_test_readOnlyActivityComplete"), _class.prototype), babelHelpers.applyDecoratedDescriptor(_class.prototype, "_test_showTestResult", [_decorators.autobind], Object.getOwnPropertyDescriptor(_class.prototype, "_test_showTestResult"), _class.prototype), babelHelpers.applyDecoratedDescriptor(_class.prototype, "_test_startedActivity", [_decorators.autobind], Object.getOwnPropertyDescriptor(_class.prototype, "_test_startedActivity"), _class.prototype), babelHelpers.applyDecoratedDescriptor(_class.prototype, "_test_endedActivity", [_decorators.autobind], Object.getOwnPropertyDescriptor(_class.prototype, "_test_endedActivity"), _class.prototype), babelHelpers.applyDecoratedDescriptor(_class.prototype, "_test_timerExpired", [_decorators.autobind], Object.getOwnPropertyDescriptor(_class.prototype, "_test_timerExpired"), _class.prototype), babelHelpers.applyDecoratedDescriptor(_class.prototype, "_test_showFinishedBanner", [_decorators.autobind], Object.getOwnPropertyDescriptor(_class.prototype, "_test_showFinishedBanner"), _class.prototype), babelHelpers.applyDecoratedDescriptor(_class.prototype, "_hideOutOfTimeModal", [_decorators.autobind], Object.getOwnPropertyDescriptor(_class.prototype, "_hideOutOfTimeModal"), _class.prototype)), _class);
exports.default = Test;